<div id="messages-list-wrapper">
  <msd-message [conversations]="conversations"
               [loading]="isLoading"
               [updating]="isUpdating"
               [emptyMessage]="'Aucun message en attente'"
               [displayMarkAsReadButton]="true"
               [origin]="'list'"
               (refresh)="loadConversations()">
  </msd-message>
</div>
